import React from "react";
import { Box, Flex, Text, Link } from "@chakra-ui/react";

function Card({ data, activeTab, navigate }) {
  return (
    <Box
      borderWidth="1px"
      borderRadius="16px"
      p={4}
      mb={4}
      bg="white"
      boxShadow="sm"
    >
      {/* Header */}
      <Flex justify="space-between" align="flex-start" gap={3} mb={2}>
        <Text fontWeight="700" fontSize="md" color="#141D43" noOfLines={2}>
          {data.name || "—"}
        </Text>

        <Text fontSize="xs" color="gray.500" whiteSpace="nowrap" mt="2px">
          {data.dateTime}
        </Text>
      </Flex>

      {/* Application Number */}
      <Text fontSize="sm" mb={1}>
        <Text as="span" fontWeight="600">
          Application Number:
        </Text>{" "}
        {data.id}
      </Text>

      {/* Scale */}
      <Text fontSize="sm" mb={1}>
        <Text as="span" fontWeight="600">
          Scale:
        </Text>{" "}
        {data.companyScale}
      </Text>

      {/* Address */}
      <Text fontSize="sm" color="gray.600" noOfLines={2}>
        <Text as="span" fontWeight="600" color="gray.700">
          Address:
        </Text>{" "}
        {data.address || "—"}
      </Text>

      {/* Action */}
      <Flex justify="flex-end" mt={4}>
        <Link
          color="#3958DC"
          fontWeight="700"
          fontSize="sm"
          onClick={() => {
            const id = encodeURIComponent(data.id);
            if (activeTab === 1) {
              navigate(`/planner/rc-form-planner/extension/${id}`);
            } else if (activeTab === 2) {
              navigate(`/planner/rc-form-planner/renew/${id}`);
            } else {
              navigate(`/planner/rc-form-planner/${id}`);
            }
          }}
        >
          View Details
        </Link>
      </Flex>
    </Box>
  );
}

export default Card;
